import React from "react";
import { string, bool } from "prop-types";
import { WithContext as ReactTags } from "react-tag-input";
import Button from "pages/_components/Button";
import { useTags } from "pages/debinPayments/hooks/useTags";

const ReactTagWithoutInput = ({ optiondebin, isReceived, isRecurrent, isEmited, isScheduled }) => {
    const { tags, handleDelete, handleCleanFilters } = useTags(
        optiondebin,
        isReceived,
        isRecurrent,
        isEmited,
        isScheduled,
    );

    if (!tags.length) {
        return null;
    }

    return (
        <>
            <ReactTags
                autofocus={false}
                tags={tags}
                handleDelete={handleDelete}
                allowDragDrop={false}
                placeholder=""
                inputProps={{
                    disabled: true,
                    autocomplete: "off",
                }}
                classNames={{
                    tags: "tagsClass",
                    selected: "selectedClass",
                    tag: "tagClass",
                    remove: "removeClass",
                }}
            />

            <Button
                image="images/figma/icon/clear-filter.svg"
                onClick={handleCleanFilters}
                label="debin.clean.filters"
                className="btn btn-link clear-filters"
                block={false}
                icon=""
            />
        </>
    );
};

ReactTagWithoutInput.propTypes = {
    optiondebin: string.isRequired,
    isReceived: bool,
    isRecurrent: bool,
    isEmited: bool,
    isScheduled: bool,
};
ReactTagWithoutInput.defaultProps = {
    isReceived: false,
    isRecurrent: false,
    isEmited: false,
    isScheduled: false,
};

export default ReactTagWithoutInput;
